<script lang="ts">
export default {
  name: "AppNavigationToolsNav",
};
</script>

<script lang="ts" setup>
import NavItem from "@/shared/components/AppNavigation/NavItem/index.vue";
import { useI18n } from "@/shared/composables/useI18n";
import { useFeatures } from "@/frontend/composables/useFeatures";
import { FeatureFlagName } from "@/services/fyApi";

const { t } = useI18n();
const { isFeatureEnabled } = useFeatures();

const route = useRoute();

const active = computed(() => {
  return [
    "tools",
    "travel-times",
    "cargo-grids",
    "trade-routes",
    "tours",
    "tour",
    "tour-add",
    "tour-join",
  ].includes(String(route.name));
});
</script>

<template>
  <NavItem
    :label="t('nav.tools.index')"
    menu-key="tools-menu"
    :submenu-active="active"
    icon="fa-duotone fa-toolbox"
  >
    <template #submenu>
      <NavItem
        :to="{ name: 'tools' }"
        :label="t('nav.tools.index')"
        icon="fa-duotone fa-browsers"
      />
      <NavItem
        :to="{ name: 'travel-times' }"
        :label="t('nav.tools.travelTimes')"
        icon="fa-duotone fa-gauge-high"
      />
      <NavItem
        v-if="isFeatureEnabled(FeatureFlagName.TOUR_PAYOUTS)"
        :to="{ name: 'tours' }"
        :label="t('nav.tools.tours')"
        icon="fa-duotone fa-coins"
      />
      <NavItem
        :to="{ name: 'cargo-grids' }"
        :label="t('nav.tools.cargoGrids')"
        icon="fa-duotone fa-thin fa-cubes"
      />
      <NavItem
        v-if="isFeatureEnabled(FeatureFlagName.TRADE_ROUTES)"
        :to="{ name: 'trade-routes' }"
        :label="t('nav.tools.tradeRoutes')"
        icon="fa-duotone fa-route"
      />
    </template>
  </NavItem>
</template>
